import { __decorate, __param } from 'tslib';
import { InjectionToken, Optional, Inject, Injectable, NgModule } from '@angular/core';
import { DOCUMENT, CommonModule } from '@angular/common';
import { ReplaySubject } from 'rxjs';
import { NavigationEnd, Router, RouterModule } from '@angular/router';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
const AT_INTERNET_CONFIG = new InjectionToken('atinternet.config');

const config = {
    site: null,
    autosend: true,
    except: []
};

/// <reference path="types/atInternet.d.ts" />
// @dynamic
let ATInternetService = class ATInternetService {
    constructor(_config, _router, _document) {
        this._config = _config;
        this._router = _router;
        this._document = _document;
        this._config = Object.assign(config, this._config);
        // Save all page calls to replay them when script is loaded
        this._pageCallsSubject = new ReplaySubject();
        this._clickCallsSubject = new ReplaySubject();
        // Is site declared?
        if (this._config.site) {
            // Load remote script
            const script = this._document.createElement('script');
            script.src = `//tag.aticdn.net/${this._config.site}/smarttag.js`;
            this._document.body.appendChild(script);
            // Autosend pages?
            if (this._config.autosend) {
                if (!Array.isArray(this._config.except)) {
                    throw new Error('ATInternetService: "except" parameter must be an array of string (string[])');
                }
                this._router.events.subscribe((value) => {
                    if (value instanceof NavigationEnd && !this._config.except.includes(value.url)) {
                        this.sendPage(value.url);
                    }
                });
            }
            // When script is loaded
            script.onload = () => {
                this._tag = new ATInternet.Tracker.Tag();
                // Replay all page calls
                this._pageCallsSubject.subscribe((page) => {
                    this._tag.page.send({ name: page });
                });
                this._clickCallsSubject.subscribe((clickInfo) => {
                    this._tag.click.send(clickInfo);
                });
            };
        }
    }
    getTag() {
        return this._tag;
    }
    sendPage(page) {
        if (!this._config.site) {
            console.warn('No ATInternet site found. Please declare one in your CoreModule config.');
        }
        else {
            this._pageCallsSubject.next(page);
        }
    }
    sendClick(clickInfo) {
        if (!this._config.site) {
            console.warn('No ATInternet site found. Please declare one in your CoreModule config.');
        }
        else {
            this._clickCallsSubject.next(clickInfo);
        }
    }
};
ATInternetService.ɵfac = function ATInternetService_Factory(t) { return new (t || ATInternetService)(ɵngcc0.ɵɵinject(AT_INTERNET_CONFIG, 8), ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(DOCUMENT)); };
ATInternetService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ATInternetService, factory: function (t) { return ATInternetService.ɵfac(t); } });
ATInternetService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [AT_INTERNET_CONFIG,] }] },
    { type: Router },
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
ATInternetService = __decorate([ __param(0, Optional()), __param(0, Inject(AT_INTERNET_CONFIG)),
    __param(2, Inject(DOCUMENT))
], ATInternetService);

let ATInternetModule = class ATInternetModule {
};
ATInternetModule.ɵfac = function ATInternetModule_Factory(t) { return new (t || ATInternetModule)(); };
ATInternetModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ATInternetModule });
ATInternetModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        ATInternetService
    ], imports: [[
            CommonModule,
            RouterModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ATInternetService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [AT_INTERNET_CONFIG]
            }] }, { type: ɵngcc1.Router }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ATInternetModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RouterModule
                ],
                providers: [
                    ATInternetService
                ],
                exports: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ATInternetModule, { imports: function () { return [CommonModule,
        RouterModule]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ATInternetModule, ATInternetService, AT_INTERNET_CONFIG };

